import { useCallback } from 'react';
import { AppFCC, PAY_MODE } from '@types';
import { usePaymentsPayWindow } from '@hooks/payments/payments-pay-window';
import { Button, BUTTON_SIZE } from '@kit/buttons/button';
import { BUTTON_BASE_COLORED_COLOR } from '@kit/buttons/button-base-colored';
import { LoadingOverlay } from '@kit/loading-overlay';
import { paymentAggregatorWindowWidgetButtonClassName, PaymentAggregatorWindowWidgetStyled, PaymentAggregatorWindowWidgetTextStyled } from './styled';
import { PaymentAggregatorWindowWidgetProps } from './types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export const PaymentAggregatorWindowWidget: AppFCC<PaymentAggregatorWindowWidgetProps> = props => {
  const {
    className,
    pending,
    payButtonOnClick
  } = props;
  const paymentsPayWindow = usePaymentsPayWindow();
  const click = useCallback(async () => {
    const _window = paymentsPayWindow.open({
      href: 'about:blank'
    });
    try {
      const payData = await payButtonOnClick();
      if (payData?.mode === PAY_MODE.WINDOW &&
      //
      payData.window.href && _window) {
        _window.location = payData.window.href;
      }
    } catch (error) {
      paymentsPayWindow.close();
    }
  }, [payButtonOnClick, paymentsPayWindow]);
  return _jsx(_Fragment, {
    children: pending ? _jsx(LoadingOverlay, {}) : _jsxs(PaymentAggregatorWindowWidgetStyled, {
      className: className,
      children: [_jsxs(PaymentAggregatorWindowWidgetTextStyled, {
        children: ["\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0412\u0430\u0448\u0435\u0433\u043E", _jsx("br", {}), "\u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F"]
      }), _jsx(Button, {
        className: paymentAggregatorWindowWidgetButtonClassName,
        color: BUTTON_BASE_COLORED_COLOR.GREEN,
        size: BUTTON_SIZE.LARGE,
        onClick: click,
        disabled: pending,
        children: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0441\u0435\u0439\u0447\u0430\u0441"
      })]
    })
  });
};